<h2 mat-dialog-title>Choose Facility to Report For</h2>
<mat-dialog-content>
  <div class="user-facilities-list">
    @for (facility of data.facilities; track facility.uuid) {
      <div class="facility-option">
        <button
          mat-flat-button
          (click)="chooseFacility(facility)"
          [disabled]="facility.uuid === data.currentActiveFacilityId"
          [attr.aria-label]="'Report for facility ' + facility.name"
        >
          {{ facility.name }}
        </button>
        @if (facility.uuid === data.currentActiveFacilityId) {
          <p>
            <mat-icon
              [attr.aria-label]="facility.name + ' Currently Active'"
              aria-hidden="false"
              fontIcon="check"
            >
            </mat-icon>
            Currently Active
          </p>
        }
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
